export default __webpack_public_path__ + "static/media/check_box_outline.84acb2fa.svg";